// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1KlGR","gfeWrapper":"CalendarEvent_gfeWrapper__jdgcl"};